/* [BD feat] Image deck text - Deck rotation */

class BdImageDeckTextStack extends HTMLElement {
  constructor() {
    super();
    this.items = [];
    this.index = 0;
    this.timer = null;
    this.interval = 0;
  }

  static get observedAttributes() {
    return ['data-interval'];
  }

  connectedCallback() {
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  attributeChangedCallback(name) {
    if (name === 'data-interval' && this.isConnected) {
      this.start();
    }
  }

  getIntervalMs() {
    const ms = parseInt(this.getAttribute('data-interval'), 10);
    return Number.isFinite(ms) && ms > 0 ? ms : 1000;
  }

  start() {
    this.stop();
    this.items = Array.from(this.querySelectorAll('.bd-image-deck-text__stack-item'));
    if (this.items.length === 0) return;

    this.interval = this.getIntervalMs();
    this.apply();

    if (this.items.length > 1) {
      this.timer = setInterval(() => this.rotate(), this.interval);
    }
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  rotate() {
    this.index = (this.index + 1) % this.items.length;
    this.apply();
  }

  apply() {
    const n = this.items.length;
    /* Shift every card one slot: front→out, middle→front, back→middle, next→back */
    this.items.forEach((el, i) => {
      const pos = (i - this.index + n) % n;
      el.classList.remove(
        'bd-image-deck-text__stack-item--front',
        'bd-image-deck-text__stack-item--middle',
        'bd-image-deck-text__stack-item--back',
        'bd-image-deck-text__stack-item--hidden'
      );
      el.style.zIndex = String(n - pos);

      if (pos === 0) el.classList.add('bd-image-deck-text__stack-item--front');
      else if (pos === 1) el.classList.add('bd-image-deck-text__stack-item--middle');
      else if (pos === 2) el.classList.add('bd-image-deck-text__stack-item--back');
      else el.classList.add('bd-image-deck-text__stack-item--hidden');
    });
  }
}

if (!customElements.get('bd-image-deck-text-stack')) {
  customElements.define('bd-image-deck-text-stack', BdImageDeckTextStack);
}
